import React from 'react';

import '../icon-component.scss';

const TemplateComponent = () => (
  <svg className="icon-component" viewBox="0 0 24 19">
    <g
      className="icon-component--none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g transform="translate(0.000000, 1.000000)">
        <polygon
          className="icon-component--none"
          points="4.87499992 17.1203497 23.3424746 17.1203497 23.3424746 4.22499993 4.87499992 4.22499993"
        />
        <path d="M7.79999987,8.12499987 L19.4999997,8.12499987" />
        <path d="M7.79999987,11.0499998 L13.6499998,11.0499998" />
        <polyline points="4.93252492 13.2203498 0.974999984 13.2203498 0.974999984 0.324999995 19.4424747 0.324999995 19.4424747 4.28154993" />
      </g>
    </g>
  </svg>
);

TemplateComponent.displayName = 'TemplateIcon';

export default TemplateComponent;
